import trackingDefaultDataTypesHydrator from './trackingDefaultDataTypes';
import trackingTourCriteriaHydrator from './trackingTourCriteria';
import getHotelsWithSamePrice from './trackingSearchData/getHotelsWithSamePrice';

export default async (options, uuid) => {
    const trackingSearchData = {};
    const timeFirstTours = options.firstCacheTime ? Math.round((options.firstCacheTime - options.timestamp) / 1000) : 0;
    const timeSearchFinished = options.searchFinishedTime ? Math.round((options.searchFinishedTime - options.timestamp) / 1000) : 0;
    const foundHotels = options?.foundHotels || [];
    const firstHotelsPrices = options?.firstHotelsPrices || {};
    const hotelsLength = foundHotels.length || 0;
    const { scannedTours } = options;
    const { error } = options;
    const trackingDefaultDataTypes = await trackingDefaultDataTypesHydrator(options);
    const trackingTourCriteria = trackingTourCriteriaHydrator(options);
    const firstCheapestHotels = getHotelsWithSamePrice({
        firstHotelsPrices,
        foundHotels,
    });
    const firstCheapestHotelsLength = firstCheapestHotels?.length || 0;

    _.extend(trackingSearchData, {
        productType: 'RailwayTourProduct',
        searchUuid: uuid,
        timeFirstTours,
        timeSearchFinished,
        hotelsLength,
        firstCheapestHotelsLength,
        scannedTours,
        error,
    }, trackingDefaultDataTypes, trackingTourCriteria);

    return trackingSearchData;
};